import * as validator from '@/utils/validate.js'
import { ValidatorChannelMask, ValidatorCheckNumber } from './validator'
// form规则

export const RulePanId = [
  {
    required: true,
    message: $t('integration.pan_id_cannot_be_empty'),
    trigger: 'blur'
  },
  {
    trigger: 'blur',
    pattern: /^[a-zA-Z0-9]{4}$/,
    message: $t('integration.panid_format_is_hexadecimal')
  }
]

export const RuleExtPanId = [
  {
    required: true,
    message: $t('integration.ext_pan_id_cannot_be_empty'),
    trigger: 'blur'
  },
  {
    trigger: 'blur',
    pattern: /^[a-zA-Z0-9]{16}$/,
    message: $t('integration.extpanid_format_is_hexadecimal')
  }
]

export const RuleChannelPage = [
  {
    required: true,
    message: '$t(integration.join_attemp_cannot_be_empty)',
    trigger: 'blur'
  },
  {
    validator: validator.FormValidate.maxMinFn('channelPage').netRule
  }
]

export const RuleChannelMask = [
  {
    required: true,
    message: $t('integration.channel_mask_cannot_be_empty'),
    trigger: 'blur'
  },
  {
    validator: ValidatorChannelMask,
    trigger: 'blur'
  }
]
export const RuleTransmitPower = [
  {
    required: true,
    message: $t('integration.transmit_power_cannot_be_empty'),
    trigger: 'blur'
  },
  {
    validator: validator.FormValidate.maxMinFn('channelPage').netRule,
    trigger: 'blur'
  }
]
export const RuleInNetInterval = [
  {
    required: true,
    message: $t('integration.the_network_access_interval_cannot_be_empty'),
    trigger: 'blur'
  },
  {
    validator: ValidatorCheckNumber,
    trigger: 'blur'
  }
]

export const RuleRequiredFunc = (message, trigger = 'blur') => {
  return {
    required: true,
    message: message,
    trigger: trigger
  }
}
